export const audioBus = {
  sounds: new Set(),

  register(sound) {
    if (sound) this.sounds.add(sound)
  },

  unregister(sound) {
    if (sound) this.sounds.delete(sound)
  },

  stopAll() {
    this.sounds.forEach((s) => {
      try { s.stop() } catch {}
    })
  },

  pauseAll() {
    this.sounds.forEach((s) => {
      try { s.pause() } catch {}
    })
  },
}
